import { KompisKeyboardInjector } from '@inter-ikea-kompis/react-components';
import { getLocale } from '@inter-ikea-storageone/shared/utils/i18nUtils';
import { usesVirtualKeyboard } from '@inter-ikea-storageone/shared/utils/platform';
import { useIntl } from 'react-intl';
import { useServiceSettings } from '@app/contexts/serviceSettings';

interface Props {
  children: React.ReactNode;
}

const VirtualKeyboardProvider = ({ children }: Props) => {
  const locale = getLocale();
  const { formatMessage } = useIntl();
  const { dexfSettings } = useServiceSettings();

  const doneButtonLabel = formatMessage({ id: 'kompis.done' });

  return usesVirtualKeyboard() ? (
    <KompisKeyboardInjector
      locale={locale}
      doneButtonLabel={doneButtonLabel}
      className={'virtualKeyboard'}
      settings={dexfSettings}
    >
      {children}
    </KompisKeyboardInjector>
  ) : (
    <>{children}</>
  );
};

export default VirtualKeyboardProvider;
